import { render, staticRenderFns } from "./officialWebsiteArticleDialog.vue?vue&type=template&id=60b4e5fe&scoped=true"
import script from "./officialWebsiteArticleDialog.vue?vue&type=script&lang=js"
export * from "./officialWebsiteArticleDialog.vue?vue&type=script&lang=js"
import style0 from "./officialWebsiteArticleDialog.vue?vue&type=style&index=0&id=60b4e5fe&prod&lang=scss&scoped=true"
import style1 from "./officialWebsiteArticleDialog.vue?vue&type=style&index=1&id=60b4e5fe&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60b4e5fe",
  null
  
)

export default component.exports